import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box, ButtonGroup, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import {AirportShuttle , History, Search, FilterList, ChevronLeft, ChevronRight, VisibilityOutlined} from "@mui/icons-material";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { CUSTOM_CONSTANTS } from "Constants";

//Services
import TriplistApi from "Services/Triplist";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";

const DriverReport = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);    
  const location = useLocation();

  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CASH", "CARD", "CORPORATE"];
  const [filtervalues , setFiltervalues] = useState({});
  const [requestId, setrequestId] = useState("");
  const [metrics,setmetrics] = useState({});
  const openaction = Boolean(anchorEl);
  const { driverRideId, driverId } = location.state || {};

  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
        setmetrics({
          kmdriven: res?.data?.data.kmdriven,
          duration: res?.data?.data.duration
        });
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    TriplistApi.getridesofdriver({ page, limit: pageSize , driver_ride_id:driverRideId, driver_id:driverId , filtervalues })
      .then(onSuccess, onFailure);
  }, [page, pageSize , filtervalues, dispatch, driverRideId, driverId]);

  const getalltriplists = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    TriplistApi.getridesofdriver({ page:1, limit: "unlimited" , driver_ride_id:driverRideId, driver_id:driverId , filtervalues:"" })
      .then(onSuccess, onFailure);
  }, [dispatch, driverRideId, driverId]);

  useEffect(() => {
    gettriplists();
    getalltriplists();
  }, [gettriplists, getalltriplists]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }; 

  const handleview = (rowData) => {
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };

  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };
 
  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    kmdriven:data?.tripDistance||0,
    duration:data?.tripMinutes||0,
    row: data,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
       sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    kmdriven:data?.tripDistance||0,
    duration:data?.tripMinutes||0,
    row: data,
  }));  
  
  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "KM driven": row.kmdriven+" KM",
    "Duration":row.duration+" Mins",
    "Earnings": CUSTOM_CONSTANTS.BASE_CURRENCY + " " + row.earnings,
    "Total": CUSTOM_CONSTANTS.BASE_CURRENCY + " " + row.total
  }));

  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "KM driven": row.kmdriven+" KM",
    "Duration":row.duration+" Mins",
    "Earnings": CUSTOM_CONSTANTS.BASE_CURRENCY + " " + row.earnings,
    "Total": CUSTOM_CONSTANTS.BASE_CURRENCY + " " + row.total
  }));   

  const handleCopy = () => {
    const header = ["S.NO", "Booking ID", "KM driven", "Duration", "Earnings", "Total"].join("\t");
    const rows = dataRows
      .map((r) => [r.sno, r.bookingid, r.kmdriven+" KM", r.duration+" Mins", CUSTOM_CONSTANTS.BASE_CURRENCY + " " + r.earnings, CUSTOM_CONSTANTS.BASE_CURRENCY + " " + r.total].join("\t"))
      .join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "kMdriven_info.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "kMdriven_info.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.bookingid,row.kmdriven+" KM",
      row.duration+" Mins",CUSTOM_CONSTANTS.BASE_CURRENCY + " "+row.earnings,CUSTOM_CONSTANTS.BASE_CURRENCY + " "+row.total,
    ]);
    doc.autoTable({
      head: [["S.NO","Booking ID","KM driven","Duration","Earnings","Total"]],
      body: tableData,
    });
    doc.save("kMdriven_info.pdf");
  };

  const handlefromdate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("fromdate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("fromdate", formattedDate);
    }
  };
  
  const handletodate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("todate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("todate", formattedDate);
    }
  };
  
  function convertToISO(inputDate) {
    if (!inputDate) return "--"; 
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return "--"; 
    return date.toISOString().replace("Z", "+00:00");
  }
    
  const handlefiltertriplist = (formValues) => {
    formValues.fromdate = convertToISO(formValues.fromdate);
    formValues.todate = convertToISO(formValues.todate);
    setFiltervalues(formValues);
  };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      paymentMode: "",
      fromdate: "",
      todate: "",
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("Status is required").nullable(),
      todate: yup.string().required("Service is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values);
    },
  });

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (  
    <Box className={classes.root}>

      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>KM Driven Duration Request Details</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / KM Driven Duration Report / <span>Request Details</span>
        </Typography>
      </Box>

      <Grid container className={classes.metricboxes} spacing={3}>
        <Grid item xs={12} md={4}>
          <Box className={classes.metricboxCard}>
            <div className={classes.metricboxContent}>
              <Typography className={classes.metricTitle}>KM DRIVEN</Typography>
              <Typography className={classes.metricValue}>{metrics.kmdriven || 0}</Typography>
            </div>
            <AirportShuttle sx={{fontSize: "80px", color: "#a5a5a5"}} className={classes.metricIcon} />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box className={classes.metricboxCard}>
            <div className={classes.metricboxContent}>
              <Typography className={classes.metricTitle}>DURATION</Typography>
              <Typography className={classes.metricValue}>{(metrics.duration || 0) + " mins"}</Typography>
            </div>
            <History sx={{fontSize: "80px", color: "#a5a5a5"}} className={classes.metricIcon} />
          </Box>
        </Grid>
      </Grid>

      <Grid container className={classes.utilities} alignItems="center">
        <Grid item xs={12} md={7} lg={7} className={classes.filtersContainer}>
          <TextField
            name="tripStatus"
            id="tripStatus"
            select
            value={formik?.values?.tripStatus || ""}
            onChange={formik?.handleChange}
            variant="outlined"
            size="small"
            SelectProps={{ displayEmpty: true }}
            className={classes.roundedFilter}
          >
            <MenuItem key="All status" value="">
              All Status
            </MenuItem>
            {Tripstatus.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            name="paymentMode"
            id="paymentMode"
            select
            value={formik?.values?.paymentMode || ""}
            onChange={formik?.handleChange}
            variant="outlined"
            size="small"
            SelectProps={{ displayEmpty: true }}
            className={classes.roundedFilter}
          >
            <MenuItem key="All payment" value="">
              All Payments
            </MenuItem>
            {Paymentmethod.map((booking) => (
              <MenuItem key={booking} value={booking}>
                {booking}
              </MenuItem>
            ))}
          </TextField>

          <div className={classes.datePickerStyle}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formik?.values?.fromdate || null}
                onChange={(newValue) => {
                  handlefromdate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" placeholder="From Date" className={classes.roundedFilter} />
                )}
              />
            </LocalizationProvider>
          </div>

          <div className={classes.datePickerStyle}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formik?.values?.todate || null}
                onChange={(newValue) => {
                  handletodate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" placeholder="To Date" className={classes.roundedFilter} />
                )}
              />
            </LocalizationProvider>
          </div>
        </Grid>

        <Grid item xs={12} md={5} lg={5} className={classes.actionsContainer}>
          <ButtonGroup className={classes.buttonGroup} variant="outlined">
            <Button onClick={handleCopy}>Copy</Button>
            <Button onClick={handleDownloadExcel}>Excel</Button>
            <Button onClick={handleDownloadCSV}>CSV</Button>
            <Button onClick={handleDownloadPDF}>PDF</Button>
          </ButtonGroup>
          <Button 
            variant="contained" 
            className={classes.moreFiltersBtn} 
            startIcon={<FilterList />}
            onClick={formik?.handleSubmit}
          >
            More Filters
          </Button>
        </Grid>
      </Grid>  

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableContainerWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Booking ID</TableCell>
              <TableCell className={classes.tableHeaderCell}>Km driven</TableCell>
              <TableCell className={classes.tableHeaderCell}>Duration</TableCell>
              <TableCell className={classes.tableHeaderCell}>Earnings</TableCell>
              <TableCell className={classes.tableHeaderCell}>Total</TableCell>
              <TableCell className={classes.tableHeaderCell} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.bookingid}
                </TableCell>
                <TableCell className={classes.tableCell}>{rowItem.kmdriven.toFixed(2)} KM</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.duration.toFixed(2)} mins</TableCell>
                <TableCell className={classes.tableCell}>{CUSTOM_CONSTANTS.BASE_CURRENCY} {rowItem.earnings.toFixed(2)}</TableCell>
                <TableCell className={classes.tableCell}>{CUSTOM_CONSTANTS.BASE_CURRENCY} {rowItem.total.toFixed(2)}</TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleview(rowItem.row)}
                  >
                    <VisibilityOutlined fontSize="small" />
                    View
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No data found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
      />
    </Box>
  );
};

export default DriverReport;
